import "./AdminTable.css"

import GeneralPaginator from '../GeneralPaginator/GeneralPaginator'

import SearchIcon from '@mui/icons-material/Search';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Fragment } from "react";

export default function AdminTable({
    atributoKey,
    colunas,
    dados,
    styleName,

    isSubtabela = false,
    temSubtabela = false,

    isPaginada = false,
    page = undefined,
    numberOfPages = undefined,
    setPage = undefined,
    setDadosByPage = undefined
}) {
    if(dados == null) {
        return (
            <span className="info-dados-vazios">
                <SearchIcon style={{width: '50px', height: '50px', marginBottom: '5px'}} />
                <span>Preencha os filtros e consulte seus dados.</span>
            </span>
        )
    }

    if(dados?.length == 0) {
        return (
            <span className="info-dados-vazios">
                <WarningAmberIcon style={{width: '50px', height: '50px', marginBottom: '5px'}} />
                <span>Não foi encontrado nenhum resultado com os filtros utilizados.</span>
            </span>
        )
    } 

    return(
        <div className={`${styleName} ${!isSubtabela ? "flex flex-col items-end gap-4" : ''}`}>
            <table className={`${!isSubtabela ? 'adm-table' : 'adm-subtable'}`}>
                <thead><tr className={`${isSubtabela ? 'adm-subtable-header' : ''}`}>
                    {colunas.map((coluna, index) => (
                        <th key={index} style={coluna.style}>{coluna.nome}</th>
                    ))}
                </tr></thead>
                <tbody>
                    {dados.map((row, index) => (<Fragment key={index}>
                        <tr key={row[atributoKey]} className={`adm-table-row ${row.className}`} ref={row.rowRef}>
                            {colunas.map((coluna, index) => (
                                <td key={index} style={coluna.style} onClick={row[`${coluna.atributo}_onClick`]}>{row[coluna.atributo]}</td>
                            ))}
                        </tr>
                        {temSubtabela && row.subtabelaAberta &&
                            <tr key={`${row[atributoKey]}_sub`}><td colSpan={"100%"}>
                                <AdminTable
                                    atributoKey={row.subtabela.atributoKey}
                                    colunas={row.subtabela.colunas}
                                    dados={row.subtabela.dados}

                                    isSubtabela={true}
                                />
                            </td></tr>
                        }
                    </Fragment>))}
                </tbody>
            </table>
            {isPaginada &&
                <div className='paginator-wrapper'>
                    <GeneralPaginator
                        page={page}
                        setPage={setPage}
                        numberOfPages={numberOfPages}
                        setTableByPage={setDadosByPage}
                    />
                </div>
            }
        </div>
    )
}